module.exports = __webpack_public_path__ + "img/computer.afc03dbd.svg";